import * as React from 'react';
import { connect } from 'react-redux';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line react/prefer-stateless-function
class Form extends React.Component {
  // $FlowFixMe[missing-local-annot]
  static defaultProps = {
    className: '',
    role: 'form',
    noValidate: true
  };

  // $FlowFixMe[missing-local-annot]
  render() {
    const {
      dispatch,
      csrf,
      id,
      className,
      role,
      onSubmit,
      children,
      noValidate,
      ...extraProps
    } = this.props;
    return (
      /*#__PURE__*/
      // $FlowFixMe[cannot-spread-inexact]
      _jsxs("form", {
        id: id,
        className: className,
        role: role,
        onSubmit: onSubmit,
        noValidate: noValidate,
        ...extraProps,
        children: [csrf && csrf.enabled && /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "_csrf_token",
          value: csrf.token
        }), children]
      })
    );
  }
}
const FormConnected =
// $FlowFixMe[underconstrained-implicit-instantiation]
connect(state => ({
  // $FlowFixMe[incompatible-use]
  csrf: state.csrf
}))(Form);
export default FormConnected;